import styled from "styled-components";

export const StyledResults = styled.div`
  background-color: #000;
  color: #fff;
`;
